import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';

import { TRACK_EVENT } from '../actions/UI';

/**
 * Track an event with GTM. Default GTM setup will forward the event to GA.
 * @param {object} action - Event attributes.
 * @return {object} GTM event that gets passed to GA.
 */
const genericTrackEvent = (action) => {
  return {
    event: 'Custom event',
    category: action.category,
    action: action.action,
    label: action.label,
    value: action.value,
  };
};

// Map events to a Redux actions
const eventsMap = {
  [TRACK_EVENT]: genericTrackEvent,
};

export default createMiddleware(eventsMap, GoogleTagManager());
